import React from "react"
import cx from "classnames"
import { PiTractorDuotone, PiMapPinDuotone } from "react-icons/pi"

import { getFileUrl } from "../../services/file/file.utils"
import { getEquipmentStatus } from "../../utils/equipment"
import "./EquipmentChit.scss"

/**
 * A piece of equipment at a glance - PersonChit's equipment twin: photo (or the
 * tractor), name, and its type underneath. `pinned` shows whether it has a place on
 * the map; `selected` highlights it.
 *
 * Photos are only on the unit once its card has been opened (list rows carry ids), so
 * a populated first photo is used when there is one, the icon otherwise.
 */
const EquipmentChit = ({ item, typeById, onClick, selected, showPin, width = 37, className, style }) => {
    if (!item) {
        return null
    }

    const photo = item.image?._id ? item.image : item.photos?.[0]?._id ? item.photos[0] : null
    const type = typeById?.get(item.type)
    const status = getEquipmentStatus(item)
    const pinned = Boolean(item.mapLocation?.lat !== undefined && item.mapLocation?.lat !== null)

    return (
        <div
            className={cx("x-equipment-chit", className, { selected, clickable: Boolean(onClick) })}
            style={style}
            onClick={onClick}
        >
            {photo ? (
                <div
                    className="dna-round-avatar"
                    style={{
                        width,
                        height: width,
                        minWidth: width,
                        backgroundImage: `url(${getFileUrl(photo, { size: "preview" })})`,
                    }}
                />
            ) : (
                <div className="x-ec-icon" style={{ width, height: width, minWidth: width }}>
                    <PiTractorDuotone />
                </div>
            )}
            <div className="x-ec-text">
                <div className="x-ec-name">{item.title}</div>
                <div className="dna-smaller-text">
                    {[type?.name, item.sku].filter(Boolean).join(" · ") || "No type"}
                    {status !== "Available" && <span className="x-ec-status"> · {status}</span>}
                </div>
            </div>
            {showPin && (
                <PiMapPinDuotone
                    className={cx("x-ec-pin", { pinned })}
                    title={pinned ? "On the map" : "Not on the map yet"}
                />
            )}
        </div>
    )
}

export default EquipmentChit
